<template>
  <loadmore ref="loadMore" :autoFill="false" :topMethod="reload" :bottomMethod="loadMore">
    <slot></slot>
  </loadmore>
</template>
<script>
  import {Loadmore} from 'mint-ui'

  export default {
    components: {Loadmore},
    props: {
      loadNextPage: {
        type: Function,
        required: true
      },
      clear: {
        type: Function,
        required: true
      }
    },
    methods: {
      reload () {
        this.end = false
        this.clear()
        this.loadMore(true)
      },
      async loadMore (isRefresh = false) {
        try {
          await this.loadNextPage()
        } finally {
          if (isRefresh) {
            this.$refs.loadMore.onTopLoaded()
          } else {
            this.$refs.loadMore.onBottomLoaded()
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?fe58b0dc